import { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-modal';
import Select from "react-select";
import Swal from "sweetalert2";
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import '../../Tabs/tabs.css';


function ForwardingInt() {
    const [openRow, setOpenRow] = useState(null);                 // To Get Branch Data
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [getVendor, setGetVendor] = useState([]);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [formData1, setFormData1] = useState({
        fromDate: firstDayOfMonth,
        toDate: today,
    });
    const [formData, setFormData] = useState({
        DocketNo: "",
        VendorCode: "",
        ForwardNo: "",
        BookDate: new Date(),
    });
    const handleFormChange = (value, key) => {
        setFormData1({ ...formData1, [key]: value })
    }
    const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        const queryParams = {
            FromDate: formData1?.fromDate
                ? formData1.fromDate.toISOString().split("T")[0]
                : "",
            ToDate: formData1?.toDate
                ? formData1.toDate.toISOString().split("T")[0]
                : "",
            Customer_Code: JSON.parse(localStorage.getItem("Login"))?.Customer_Code || "",
            Branch_Code: JSON.parse(localStorage.getItem("Login"))?.Branch_Code || ""
        };

        const response = await getApi(
            `/Booking/ForwardingGetDetails?FromDate=${queryParams.FromDate}&ToDate=${queryParams.ToDate}&Customer_Code=${queryParams.Customer_Code}&Branch_Code=${queryParams.Branch_Code}`
        );

        if (response?.status === 1) {
            setData(response.data);
        } else {
            setData([]);
            Swal.fire("Info", response?.message || "No data found", "info");
        }

    } catch (err) {
        console.error(err);
        Swal.fire("Error", "Failed to fetch forwarding details", "error");
    }
};

    const fetchVendorData = async () => {
        try {
            const response = await getApi('/Master/getVendor');
            setGetVendor(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.error('Fetch Error:', err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchVendorData();
    }, []);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(data.length / rowsPerPage);

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const parseDDMMYYYY = (dateStr) => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/");
        return new Date(year, month - 1, day);
    };


    const handleUpdate = async (e) => {
        e.preventDefault();

        const requestBody = {
            DocketNo: formData.DocketNo,
            ConnentDate: formData.BookDate,     // make sure this is date/string as backend expects
            VendorAwbNo: formData.ForwardNo,    // mapping ForwardNo → VendorAwbNo
            Vendor_Code: formData.VendorCode,
        };

        try {
            const response = await postApi(
                '/Booking/UpdateVendorAwbnoforTracking',
                requestBody,
            );
            console.log(response);
            if (response.status === 1) {
                Swal.fire(
                    'Updated!',
                    response.message || 'Vendor AWB updated successfully.',
                    'success'
                );

                setModalIsOpen(false);
                handleSubmit(e);

                setFormData({
                    DocketNo: "",
                    VendorCode: "",
                    ForwardNo: "",
                    BookDate: new Date(),
                });

            } else {
                Swal.fire(
                    'Error!',
                    response.message || 'Update failed.',
                    'error'
                );
            }

        } catch (error) {
            console.error("UpdateVendorAwbnoforTracking Error:", error);
            Swal.fire(
                'Error',
                'Failed to update Vendor AWB',
                'error'
            );
        }
    };









    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    return (
        <>
            <div className="body">
                <div className="container1">


                    <form style={{ margin: "0px", padding: "0px", backgroundColor: "#f2f4f3" }} onSubmit={handleSubmit}>
                        <div className="fields2" style={{ display: "flex", alignItems: "center" }}>

                            <div className="input-field3">
                                <label htmlFor="">From Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData1.fromDate}
                                    onChange={(date) => handleFormChange(date, "fromDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>

                            <div className="input-field3">
                                <label htmlFor="">To Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData1.toDate}
                                    onChange={(date) => handleFormChange(date, "toDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>
                            <div className="bottom-buttons" style={{ marginTop: "20px", marginLeft: "10px" }}>
                                <button className="ok-btn" style={{ height: "35px" }} type="submit">Submit</button>
                            </div>

                            <div style={{ display: "flex", flex: "1", justifyContent: "end", marginTop: "10px" }}>
                                <div className="search-input mt-2">
                                    <input style={{}} className="add-input" type="text" placeholder="search" />
                                    <button type="submit" title="search">
                                        <i className="bi bi-search"></i>
                                    </button>
                                </div>

                            </div>

                        </div>
                    </form>

                    <div className='table-container'>
                        <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
                            <thead className='table-sm'>
                                <tr>
                                    <th scope="col">Sr.No</th>
                                    <th scope="col">Docket No</th>
                                    <th scope="col">Book Date</th>
                                    <th scope="col">Customer Name</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Vendor Name</th>
                                    <th scope="col">Forwarding No</th>

                                </tr>
                            </thead>
                            <tbody className='table-body'>

                                {currentRows.map((forward, index) => (
                                    <tr key={index} style={{ fontSize: "12px", position: "relative" }}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                style={{ fontSize: "14px", fontWeight: "bold", color: "#4FD1C5" }}

                                                onClick={() => {
                                                    setFormData({
                                                        DocketNo: forward.DocketNo,
                                                        VendorCode: forward.Vendor_Code,
                                                        ForwardNo: forward.VendorAwbNo,
                                                        BookDate: parseDDMMYYYY(forward.Bookdate),
                                                    });

                                                    setModalIsOpen(true);
                                                }}

                                            >
                                                {forward.DocketNo}
                                            </button>
                                        </td>

                                        <td>{forward.Bookdate}</td>
                                        <td>{forward.Customer_Name}</td>
                                        <td>{forward.Qty}</td>
                                        <td>{forward.Vendor_Name}</td>
                                        <td>{forward.VendorAwbNo}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div className="pagination">
                            <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>{"<"}</button>
                            <span style={{ color: "#333", padding: "5px" }}>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>{">"}</button>
                        </div>

                        <div className="rows-per-page" style={{ display: "flex", flexDirection: "row", color: "black", marginLeft: "10px" }}>
                            <label style={{ marginTop: "16px", marginRight: "10px" }}>Rows per page:</label>
                            <select style={{ height: "40px", width: "60px", marginTop: "10px" }} value={rowsPerPage} onChange={handleRowsPerPageChange}>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                                <option value={500}>500</option>
                            </select>
                        </div>
                    </div>




                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen}
                        className="custom-modal-volumetric" contentLabel="Modal" style={{
                            content: {
                                height: 'auto',
                                whiteSpace: "nowrap"
                            },
                        }}>
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>Forwarding Master</header>
                            </div>
                            <div className='container2'>
                                <form onSubmit={handleUpdate}>
                                    <div className="fields2">
                                        <div className="input-field">
                                            <label htmlFor="">Booking Date</label>
                                            <DatePicker
                                                portalId="root-portal"
                                                selected={formData.BookDate}
                                                onChange={date => setFormData({ ...formData, BookDate: date })}
                                                dateFormat="dd/MM/yyyy"
                                            />

                                        </div>

                                        <div className="input-field">
                                            <label htmlFor="">Docket No</label>
                                            <input
                                                placeholder="Docket No"
                                                value={formData.DocketNo}
                                                onChange={e => setFormData({ ...formData, DocketNo: e.target.value })}
                                                required
                                            />

                                        </div>

                                        <div className="input-field">
                                            <label htmlFor="">Vendor Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={getVendor.map(ven => ({
                                                    value: ven.Vendor_Code,   // adjust keys from your API
                                                    label: ven.Vendor_Name
                                                }))}
                                                value={
                                                    formData.VendorCode
                                                        ? { value: formData.VendorCode, label: getVendor.find(ven => ven.Vendor_Code === formData.VendorCode)?.Vendor_Name || '' }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    setFormData({
                                                        ...formData,
                                                        VendorCode: selectedOption ? selectedOption.value : ""
                                                    })
                                                }}
                                                placeholder="Select Vendor"
                                                isSearchable
                                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                                }} />
                                        </div>


                                        <div className="input-field">
                                            <label htmlFor="">Forwarding No</label>
                                            <input
                                                placeholder="Forward No"
                                                value={formData.ForwardNo}
                                                onChange={e => setFormData({ ...formData, ForwardNo: e.target.value })}
                                                required
                                            />
                                        </div>



                                    </div>

                                    <div className='bottom-buttons'>
                                        <button type='submit' className='ok-btn'>Submit</button>
                                        <button type="button" onClick={() => setModalIsOpen(false)} className='ok-btn'>close</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >
                </div>
            </div>
        </>
    )
}


export default ForwardingInt;